import { useI18n } from 'vue-i18n';
import type { SpmFieldConfig } from '@/components/table-rest-api/types';

export default function useOptinFilterFields(): SpmFieldConfig[] {
  const { t } = useI18n();

  // optin_data_* is forced to 0 on unsubscribe, so value 0 also covers unsubscribed contacts.
  const options = [
    { label: t('myLists.manage.customers.optin.0'), value: 0 },
    { label: t('myLists.manage.customers.expansion.status.simpleOptin'), value: 1 },
    { label: t('myLists.manage.customers.expansion.status.doubleOptin'), value: 2 },
  ];

  const optinField = (name: string, label: string): SpmFieldConfig => ({
    name,
    label,
    filterable: true,
    filterConfig: {
      type: 'multiSelect',
      options,
    },
  });

  return [
    optinField('optin_email', t('myLists.manage.customers.headers.optinEmail')),
    optinField('optin_sms', t('myLists.manage.customers.headers.optinSms')),
  ];
}
